import { gql } from '@apollo/client';

export const GET_INVITE_INFO = gql`
  query GetInviteInfo($token: String!) {
    getInviteInfo(token: $token) {
      isExistingUser
    }
  }
`;

export const GET_CURRENT_USER = gql`
  query GetCurrentUser {
    getCurrentUser {
      _id
      email
      role
    }
  }
`;

export const GET_PENDING_COACH_REQUESTS = gql`
query GetPendingCoachRequests {
    getPendingCoachRequests {
      _id
      firstName
      lastName
      email
      organization
      profilePicture
      createdAt
    }
  }
  `;

export const GET_APPROVED_COACHES = gql`
query GetApprovedCoaches {
  getApprovedCoaches {
    _id
    firstName
    lastName
    profilePicture
    organization
    user {
      email
    }
    athletes {
      _id
    }
  }
}
`;